;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"7d3f10787ea66ed101e8662a82a538f3bdd5b1b9"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/play";import * as Sentry from '@sentry/nextjs';

import {
  CORE_ERROR_PATTERNS,
  createBeforeSend,
  PHASER_ERROR_PATTERNS,
  WEBRTC_ERROR_PATTERNS,
  WHALE_BROWSER_ERROR_PATTERNS,
} from '@zep/sentry';

import baseOptions from '../../sentry.base.config';

Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [
      ...CORE_ERROR_PATTERNS,
      ...PHASER_ERROR_PATTERNS,
      ...WEBRTC_ERROR_PATTERNS,
      ...WHALE_BROWSER_ERROR_PATTERNS,
    ],
  }),
});
